import React, { useState, useEffect } from "react";
import { View } from "react-native";

import { Text, ConfirmAlert, DeleteAlertComponent } from "components";
import FactorItemCard from "./factorItemCard";

import css from "styles";
import { sizes, colors, strings } from "assets/constants";
import { changeArrayAt, removeArrayItemAt } from "utils";

type ItemsProps = {
  disableAction?: boolean;
  items: Array<FactorItemT>;
  onChange: (items: Array<FactorItemT>) => void;
  activeStepPriority?: number;
  getChangeStepData: (itemId: number, stepId: string, count: number) => void;
  onCloseChangeStep: (itemId: number) => void;
};

const Items: React.FC<ItemsProps> = ({
  items,
  onChange,
  activeStepPriority,
  getChangeStepData,
  onCloseChangeStep,
  disableAction,
}) => {
  const [itemsState, setItemsState] = useState<Array<FactorItemT>>(items);
  useEffect(() => {
    setItemsState(items);
  }, [items]);

  const visibleItems = itemsState?.filter(
    (e) => e?.status?.priority === activeStepPriority
  );

  // *** edit item logic
  const _onEditCount = (itemId: number, itemPrice: number, count: number) => {
    const itemIndex = itemsState?.findIndex((e) => e.id === itemId);
    const newItem = {
      ...itemsState[itemIndex],
      count,
      total_price: count * itemPrice,
    };
    const newItemsState = changeArrayAt(itemsState, itemIndex, newItem);
    onChange(newItemsState);
  };

  // *** remove item logic
  const [itemIdToRemove, setItemIdToRemove] = useState<null | number>(null);
  const _goToRemove = (itemId: number) => {
    setItemIdToRemove(itemId);
  };
  const _closeRemove = () => setItemIdToRemove(null);
  const _onRemoveItem = (close: () => void) => {
    if (!itemIdToRemove) {
      return;
    }

    const itemIndex = itemsState?.findIndex((e) => e.id === itemIdToRemove);
    const newItemsState = removeArrayItemAt([...itemsState], itemIndex);
    onChange(newItemsState);
    close();
  };

  // *** render ui
  if (visibleItems?.length === 0) {
    return (
      <Text
        size="sm"
        color={colors.textColorGray}
        style={{ marginBottom: sizes.space / 2 }}
      >
        {strings.not_exists_any_product_in_this_step}
      </Text>
    );
  }

  return (
    <>
      <View style={css.responsiveListContainer}>
        {visibleItems?.map((item: FactorItemT, key: number) => {
          return (
            <View key={String(key)} style={css.responsiveBoxContainer}>
              <FactorItemCard
                item={item}
                onRemove={_goToRemove}
                onChangeCount={_onEditCount}
                onChangeStepData={getChangeStepData}
                onCloseChangeStep={onCloseChangeStep}
                disableAction={disableAction}
              />
            </View>
          );
        })}
      </View>

      <ConfirmAlert
        force
        hide={_closeRemove}
        show={itemIdToRemove !== null}
        renderContent={(close) => (
          <DeleteAlertComponent
            cancel={close}
            removeLoading={false}
            remove={() => _onRemoveItem(close)}
          />
        )}
      />
    </>
  );
};

export default Items;
